import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import {
	Box, Button, TextField, Grid, Link, FormControl, FormHelperText, InputAdornment, Paper, IconButton
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Formik, getIn } from "formik";
import clsx from "clsx";
import * as Yup from "yup";

import { Analytics } from "../common";
import * as routes from "../../constants/routes";
import LogoEasyPayslip from "../../assets/images/LOGOEasyPayslipHorizontal.svg";
import { ExternalUserStyle } from "./sessionStyle";
import Slider from "react-slick";
import * as OnboardActions from "../../actions/OnboardActions";

class quickSetupComponent extends Component {

	constructor(props) {
		super(props);
		this.state = {
			currentIndex: 0,
			dotsClass: "",
			lastActiveIndex: 0,
			isNameValid: false,
			isEmailValid: false,
			isPasswordValid: false,
			showPassword: false,
			isPhoneValid: true
		};
	}

	validationSchema = Yup.object({
		businessData: Yup.object().shape({
			businessName: Yup.string().matches(/^([0-9a-zA-Z .,?!(){}:;'|\-_=\/@#$%*=&"]){0,50}$/, {
				message: 'Please enter a valid business name',
				excludeEmptyString: true
			})
				.required("Business Name is required"),
			email: Yup.string().matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, {
				message: 'Please enter a valid email address',
				excludeEmptyString: true
			})
				.email("Please enter a valid email address")
				.required("Email is required"),
			password: Yup.string()
				.min(7, "Please enter at least 7 characters")
				.required("Password is required"),
			phone: Yup.string().matches(/^(0011[0-9]{2}?|(\+[0-9]{2})|0)?[0-9]{9}$/, {
				message: 'Please enter a valid phone number',
				excludeEmptyString: true
			})
		}),
	});

	componentDidMount() {
		Analytics.OB_1BusinessNameScreen();
	}

	componentWillMount() {
		const { cleanMessageOnboard } = this.props;
		cleanMessageOnboard()
	}

	componentWillReceiveProps = (nextProps) => {
		const { updateOnboardingSucsee, history, messageCode, accountData, accountType, businessData } = nextProps;

		if (updateOnboardingSucsee) {
			console.log('updateOnboardingSucsee', updateOnboardingSucsee, '\nthis.state.currentIndex', this.state.currentIndex)
			if (accountType && accountType === "accountant")
				history.push(routes.PATH_QUICK_SETUP_ACCOUNTANT, { goSlide: 3 });
			switch (this.state.currentIndex) {
				case 0:
					Analytics.updateProfileNameAction(businessData)
					Analytics.OB_1BusinessNameAction();
					break;
				case 1:
					Analytics.updateProfileNameAction(businessData)
					Analytics.OB_2EmailAction();
					break;
				case 2:
					Analytics.AccountSignupAction();
					break;
				case 3:
					let businessDataNew = {
						...businessData
					}

					let $first_name = nextProps.businessData.fullName.split(" ")[0];
					let $last_name = nextProps.businessData.fullName.split(" ")[1];
					businessDataNew.firstName = $first_name
					businessDataNew.lastName = $last_name

					Analytics.updateProfileNameAction(businessDataNew, accountData && accountData.employer && accountData.employer.id)

					messageCode === 200 && accountData && history.push(routes.PATH_QU_SE_SUCCESS);
					break;
			}
			this.state.currentIndex !== 3 && this.slider.slickNext();
		}
	};

	handleClickShowPassword = () => {
		const { showPassword } = this.state;
		this.setState({ showPassword: !showPassword });
	};

	handleSubmitSignUp = (values, actions) => {
		const { signUp, history } = this.props;
		actions.setSubmitting(false);
		signUp(values.email, values.password, history);
	};

	onKeyPress(event, formProps) {
		if ((event.charCode === 13 || event.charCode === 10) && this.shouldNextBtnBeActive(this.state.currentIndex)) {
			this.handleNext(null, formProps);
		}
	}

	handleNext = (event, formProps) => {
		const { updateDataboarding, cleanMessageOnboard, businessData } = this.props;

		const { currentIndex } = this.state;
		let businessInf = {}
		let businessDataNew = {
			...businessData
		}

		cleanMessageOnboard();

		switch (currentIndex) {
			case 0:
				businessInf["businessName"] = formProps.values.businessData.businessName
				businessDataNew.businessName = formProps.values.businessData.businessName
				break;
			case 1:
				businessInf["email"] = formProps.values.businessData.email;
				businessDataNew.email = formProps.values.businessData.email;
				break;
			case 2:
				businessInf["password"] = formProps.values.businessData.password
				businessDataNew.password = formProps.values.businessData.password
				break;
			case 3:
				businessInf["fullName"] = formProps.values.businessData.fullName
				if (formProps.values.businessData.phone != "") {
					businessInf["phone"] = formProps.values.businessData.phone
				}

				businessDataNew.fullName = formProps.values.businessData.fullName
				businessDataNew.phone = formProps.values.businessData.phone
				break;
		}
		let isQS_Employer = true
		let isQS_Accountant = false

		updateDataboarding(businessInf, businessDataNew, this.state.currentIndex, isQS_Employer, isQS_Accountant);
	};

	handlePrevious = () => {
		this.slider.slickPrev();
	};

	handleChange = (event, fromProps) => {
		const newValue = event.target.value;

		fromProps.setFieldValue(event.target.id, newValue);
		this.setValidationStates(this.state.currentIndex, newValue, fromProps, event);

	};

	afterChange = (current) => {

		switch (current) {
			case 0:
				Analytics.OB_1BusinessNameScreen();
				break;
			case 1:
				Analytics.OB_2EmailScreen();
				break;
			case 2:
				Analytics.OB_3PasswordScreen();
				break;
			case 3:
				Analytics.OB_4ContactAScreen()
				break;
		}
		this.setState({
			currentIndex: current,
			lastActiveIndex: current > this.state.lastActiveIndex ? current : this.state.lastActiveIndex
		})
	};

	beforeChange = (oldIndex, newIndex) => {
		this.setState({
			currentIndex: newIndex
		});
	}

	shouldNextBtnBeActive = (current) => {
		switch (current) {
			case 0:
				return this.state.isNameValid;
			case 1:
				return this.state.isEmailValid;
			case 2:
				return this.state.isPasswordValid
			case 3:
				return this.state.isPhoneValid
		}
	}

	setValidationStates = (current, newValue, formProps, event) => {

		switch (current) {
			case 0:
				if (newValue.trim().match(/^([0-9a-zA-Z .,?!(){}:;'|\-_=\/@#$%*=&"]){1,50}$/)) {
					this.setState({
						lastActiveIndex: current,
						isNameValid: true
					});
				}
				else {
					this.setState({
						lastActiveIndex: current,
						isNameValid: false
					});
				}
				break;
			case 1:
				if (newValue.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
					this.setState({
						lastActiveIndex: current,
						isEmailValid: true,
					});
				}
				else {
					this.setState({
						lastActiveIndex: current,
						isEmailValid: false
					});
				}
				break;
			case 2:
				if (newValue.length >= 7 && formProps.values.businessData.password.length >= 6) {
					this.setState({
						lastActiveIndex: current,
						isPasswordValid: true,
					});
				}
				else {
					this.setState({
						lastActiveIndex: current,
						isPasswordValid: false
					});
				}
				break;
			case 3:
				if (event.target.id === "businessData.phone") {

					if (newValue.length === 0 || newValue.match(/^(0011[0-9]{2}?|(\+[0-9]{2})|0)?[0-9]{9}$/)) {
						this.setState({
							lastActiveIndex: current,
							isPhoneValid: true
						});
					}
					else {
						this.setState({
							lastActiveIndex: current,
							isPhoneValid: false
						});
					}

				}
				break;
		}
	}

	// { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, }
	renderForm = (formProps) => {
		const { classes, error, errorMessage, onboard } = this.props;
		const { currentIndex, showPassword } = this.state;

		var settings = {
			dots: true,
			dotsClass: `slick-dots slick-dots-quickSetup`,
			infinite: false,
			speed: 250,
			autoplaySpeed: 4000,
			slidesToShow: 1,
			touchMove: false,
			slidesToScroll: 1,
			fade: true,
			arrows: false,
			afterChange: (current, next) => this.afterChange(current, next),
			beforeChange: (current, next) => this.beforeChange(current, next),
			className: "quickSetupSlide",
			appendDots: () => <ul>
				<li class={this.state.currentIndex === 0 ? "slick-active" : ""} ><button onClick={() => this.slider.slickGoTo(0)}>1</button></li>
				<li class={`${this.state.currentIndex === 1 ? "slick-active" : ""} ${this.state.lastActiveIndex < 1 ? "qs-noHover" : ""}`}><button disabled={this.state.lastActiveIndex < 1 ? true : false} onClick={() => this.slider.slickGoTo(1)}>2</button></li>
				<li class={`${this.state.currentIndex === 2 ? "slick-active" : ""} ${this.state.lastActiveIndex < 2 ? "qs-noHover" : ""}`}><button disabled={this.state.lastActiveIndex < 2 ? true : false} onClick={() => this.slider.slickGoTo(2)}>3</button></li>
				<li class={`${this.state.currentIndex === 3 ? "slick-active" : ""} ${this.state.lastActiveIndex < 3 ? "qs-noHover" : ""}`}><button disabled={this.state.lastActiveIndex < 3 ? true : false} onClick={() => this.slider.slickGoTo(3)}>4</button></li>
			</ul>
		};

		return (
			<Grid container className={classes.quickSetupRoot}>
				<Grid className={classes.quickSetupRoot} container alignItems="flex-start">
					<Grid container className={classes.rootContainer} style={{ height: "460px", padding: "50px" }}>
						<Grid container className={classes.logoEasyPayslip} item xs={12} style={{ height: 0 }}>
							<Grid item xl={6} lg={6} md={6} sm={6}  >
								<img src={LogoEasyPayslip} alt="" />
							</Grid>
							<Grid item xl={6} lg={6} md={6} sm={6} >
								{/* <label className={classes.subTitleOne} style={{ maxWidth: "initial", fontFamily: "AvenirNextLTPro-Regular", }}>
									Quick Setup
						    	</label> */}
							</Grid>
						</Grid>
						<Grid item xs={12} style={this.state.currentIndex === 1 ? { marginTop: -30 } : {}}>
							<div className={classes.slideShow}>
								<Slider ref={c => (this.slider = c)} {...settings}>
									{/* slide item one */}
									<div>
										{this.state.currentIndex === 0 && <div className={classes.slideShowItem}>
											<div>
												<div>
													<div className={classes.titleWrapper2}>
														<h1 className={classes.title}>
															What’s your
												<br />
															business name?
                                               </h1>
														<label className={classes.subTitleOne} style={{ maxWidth: "initial", fontFamily: "AvenirNextLTPro-Regular" }}>
															We’ll put this on
													 <br />
															your payslips
									        	</label>
													</div>
												</div>
											</div>
											<div>
												<Grid item>
													<Paper className={classes.paperGrid} style={{ marginTop: 25 }}>
														<TextField
															autoFocus={this.state.currentIndex === 0}
															fullWidth
															id="businessData.businessName"
															label="Business Name*"
															variant="filled"
															value={formProps.values.businessData.businessName}
															onChange={event => this.handleChange(event, formProps)}
															onBlur={formProps.handleBlur}
															onKeyPress={(event) => this.onKeyPress(event, formProps)}
															className={clsx(classes.textFieldQuickSetup, {
																error: getIn(formProps.errors, "businessData.businessName") && getIn(formProps.touched, "businessData.businessName")
															})}
														/>
														{getIn(formProps.errors, "businessData.businessName") && getIn(formProps.touched, "businessData.businessName") &&
															<FormHelperText error>{formProps.errors.businessData.businessName}</FormHelperText>}
													</Paper>
												</Grid>

											</div>
										</div>}
									</div>

									{/* slide item two */}
									<div>
										{this.state.currentIndex === 1 && <div className={classes.slideShowItem}  >
											<div>
												<div>
													<div className={classes.titleWrapper2}>
														<h1 className={classes.title}>
															What is your
												<br />
															email address?
                                               </h1>
														<label className={classes.subTitleOne} style={{ maxWidth: "initial", fontFamily: "AvenirNextLTPro-Regular" }}>
															So we can create

															your account
									        	</label>
													</div>
												</div>
											</div>
											<div>
												<Grid item>
													<Paper className={classes.paperGrid} style={{ marginTop: 25 }}>
														<TextField
															fullWidth
															InputProps={
																{
																	autocomplete: "new-email",
																	form: {
																		autocomplete: "off",
																	}
																}
															}
															type="email"
															autoComplete="off"
															id="businessData.email"
															label="Email*"
															variant="filled"
															autoFocus={this.state.currentIndex === 1}
															value={formProps.values.businessData.email}
															onChange={event => this.handleChange(event, formProps)}
															onBlur={formProps.handleBlur}
															onKeyPress={(event) => this.onKeyPress(event, formProps)}
															className={clsx(classes.textFieldQuickSetup, {
																error: getIn(formProps.errors, "businessData.email") && getIn(formProps.touched, "businessData.email")
															})}
														/>
														{getIn(formProps.errors, "businessData.email") && getIn(formProps.touched, "businessData.email") &&
															<FormHelperText error>{formProps.errors.businessData.email}</FormHelperText>}
													</Paper>
												</Grid>

											</div>
										</div>}
									</div>


									{/* slide item tree */}
									<div>
										{this.state.currentIndex === 2 && <div className={classes.slideShowItem}>
											<div>
												<div>
													<div className={classes.titleWrapper2}>
														<h1 className={classes.title}>
															Add a
												<br />
															password
                                               </h1>
														<label className={classes.subTitleOne} style={{ maxWidth: "initial", fontFamily: "AvenirNextLTPro-Regular", width: 250 }}>
															Make sure you add at

															least seven characters
									        	</label>
													</div>
												</div>
											</div>
											<div>
												<Grid item>
													<Paper className={classes.paperGrid} style={{ marginTop: 25 }}>
														<TextField
															fullWidth
															type={showPassword ? "text" : "password"}
															inputProps={
																{
																	autocomplete: "new-password",
																	form: {
																		autocomplete: "off",
																	}
																}
															}
															autoComplete="off"
															id="businessData.password"
															label="Password*"
															variant="filled"
															autoFocus={this.state.currentIndex === 2}
															value={formProps.values.businessData.password}
															onChange={event => this.handleChange(event, formProps)}
															onBlur={formProps.handleBlur}
															onKeyPress={(event) => this.onKeyPress(event, formProps)}
															className={clsx(classes.textFieldQuickSetup, {
																error: getIn(formProps.errors, "businessData.password") && getIn(formProps.touched, "businessData.password")
															})}
														// InputProps={{
														// 	endAdornment: (
														// 		<InputAdornment position="end">
														// 			<IconButton edge="end" aria-label="Toggle password visibility" onClick={this.handleClickShowPassword}>
														// 				{showPassword ? <VisibilityOff /> : <Visibility />}
														// 			</IconButton>
														// 		</InputAdornment>
														// 	)
														// }}
														/>
														{getIn(formProps.errors, "businessData.password") && getIn(formProps.touched, "businessData.password") &&
															<FormHelperText error>{formProps.errors.businessData.password}</FormHelperText>}
													</Paper>
												</Grid>
											</div>
										</div>}
									</div>

									{/* slide item four */}
									<div>
										{this.state.currentIndex === 3 && <div className={classes.slideShowItem}>
											<div>
												<div>
													<div className={classes.titleWrapper2}>
														<h1 className={classes.title}>
															What do

															we call you?
                                               </h1>
														<label className={classes.subTitleOne} style={{ maxWidth: "initial", fontFamily: "AvenirNextLTPro-Regular" }}>
															Add your preferred
													 <br />
															name & number
									        	</label>
													</div>
												</div>
											</div>
											<div>
												<Grid item>
													<Paper className={classes.paperGrid} style={{ marginTop: 25 }}>
														<TextField
															fullWidth
															id="businessData.fullName"
															label="Name (optional)"
															variant="filled"
															autoFocus={this.state.currentIndex === 3}
															value={formProps.values.businessData.fullName}
															onChange={event => this.handleChange(event, formProps)}
															onKeyPress={(event) => this.onKeyPress(event, formProps)}
															onBlur={formProps.handleBlur}
															className={clsx(classes.textFieldQuickSetup)}
														/>
													</Paper>

													<Paper className={classes.paperGrid} style={{ marginTop: 25 }}>
														<TextField
															id="businessData.phone"
															label="Phone number (optional)"
															variant="filled"
															value={formProps.values.businessData.phone}
															onChange={event => this.handleChange(event, formProps)}
															onKeyPress={(event) => this.onKeyPress(event, formProps)}
															onBlur={formProps.handleBlur}
															fullWidth
															className={clsx(classes.textFieldQuickSetup, {
																error: getIn(formProps.errors, "businessData.phone") && getIn(formProps.touched, "businessData.phone")
															})}
														/>
														{getIn(formProps.errors, "businessData.phone") && getIn(formProps.touched, "businessData.phone") &&
															<FormHelperText error>{formProps.errors.businessData.phone}</FormHelperText>}
													</Paper>
												</Grid>
												<Grid item >
													<FormControl fullWidth margin="normal">
														<Box m={0.1} />
														<Button variant="contained" color="primary" style={{ width: "100%" }} className={classes.signupBtn}
															disabled={!this.shouldNextBtnBeActive(this.state.currentIndex)}
															onClick={event => this.handleNext(event, formProps)}
															type="submit">
															Activate Free Trial
										              	</Button>
													</FormControl>
												</Grid>
											</div>
										</div>}
									</div>
								</Slider>
								<div className={classes.quSeBtnWrapper} style={{ top: `${currentIndex === 3 ? "220px" : ""}` }}>
									{currentIndex > 0 && <div style={{ paddingTop: "5px", marginRight: "auto" }}>
										<Button style={{ minWidth: "70px" }} color="primary"
											onClick={event => this.handlePrevious(event, formProps)}
											className={classes.backText}
										>Back</Button>
									</div>}
									<div>
										{currentIndex < 3 && <Button variant="contained" color="primary"
											disabled={!this.shouldNextBtnBeActive(this.state.currentIndex)}
											className={clsx(classes.quSeBtn, { [classes.disabledButtonPrimary]: !this.shouldNextBtnBeActive(this.state.currentIndex) })}
											onClick={event => this.handleNext(event, formProps)}
											type="submit">
											Next
											</Button>}
									</div>
								</div>
							</div>
						</Grid>
					</Grid>
				</Grid>
			</Grid >
		);
	};

	render() {
		const { classes, businessData } = this.props;

		const quickSetupData = {
			businessData: {
				...businessData
			}
		};

		return (
			<Grid container className={classes.root}>
				<Formik initialValues={{ ...quickSetupData }} validationSchema={this.validationSchema} onSubmit={this.handleSubmitSignUp} render={this.renderForm} />
			</Grid>
		);
	}
}

quickSetupComponent.propTypes = {
	history: PropTypes.object,
	classes: PropTypes.object,
	onboard: PropTypes.object,
	businessData: PropTypes.object,
	accountData: PropTypes.object,
	error: PropTypes.bool,
	updateOnboardingSucsee: PropTypes.bool,
	errorMessage: PropTypes.string,
	message: PropTypes.string,
	messageCode: PropTypes.number,
	onboardSessionid: PropTypes.string,
	signUp: PropTypes.func,
	onboardingRequest: PropTypes.func,
	accountType: PropTypes.string,
};

const mapStateToProps = state => ({
	error: state.external.error,
	onboard: state.onboard,
	message: state.onboard.message,
	onboardSessionid: state.onboard.sessionToken,
	businessData: state.onboard.businessData,
	messageCode: state.onboard.messageCode,
	updateOnboardingSucsee: state.onboard.updateOnboardingSucsee,
	accountData: state.onboard.accountData,
	accountType: state.onboard.accountType,
});

const mapDispatchToProps = dispatch => ({
	updateDataboarding: bindActionCreators(OnboardActions.updateDataDuringOnboarding, dispatch),
	finishOnboardingGetDataAccount: bindActionCreators(OnboardActions.finishOnboardingGetDataAccount, dispatch),
	cleanMessageOnboard: bindActionCreators(OnboardActions.cleanMessageOnboard, dispatch),
});

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(withStyles(ExternalUserStyle)(quickSetupComponent))
);
